<template>
<div class="chapter">
<div class="inner_page">
<div class="sgc-1" id="untitled-1"></div>
<div class="calibre1" id="untitled-111">
<div class="calibre1" id="toc">
<p class="chapter">Table of Contents</p>
<div class="calibre1">
<p class="chapter"><a href="#/Text/Preface#toc-anchor">Preface</a></p>
<p class="chapter"><a href="#/Text/Chapter_01#toc-anchor-1">Chapter One</a></p>
<p class="chapter1"><a href="#/Text/Chapter_01#toc-anchor-11">The Washington Murders</a></p>
<p class="chapter"><span href="#/Text/Chapter_02#toc-anchor-2" title="Link target outside of Sample">Chapter Two</span></p>
<p class="chapter1"><span href="#/Text/Chapter_02#toc-anchor-12" title="Link target outside of Sample">An Expanding Evil: 1974 - 1975</span></p>
<p class="chapter"><span href="#/Text/Chapter_03#toc-anchor-3" title="Link target outside of Sample">Chapter Three</span></p>
<p class="chapter1"><span href="#/Text/Chapter_03#toc-anchor-13" title="Link target outside of Sample">New Killing Grounds: 1975</span></p>
<p class="chapter"><span href="#/Text/Chapter_04#toc-anchor-4" title="Link target outside of Sample">Chapter Four</span></p>
<p class="chapter1"><span href="#/Text/Chapter_04#toc-anchor-14" title="Link target outside of Sample">The Unmasking</span></p>
<p class="chapter"><span href="#/Text/Chapter_05#toc-anchor-5" title="Link target outside of Sample">Chapter Five</span></p>
<p class="chapter1"><span href="#/Text/Chapter_05#toc-anchor-15" title="Link target outside of Sample">The Road to the End</span></p>
<p class="chapter"><span href="#/Text/Chapter_06#toc-anchor-6" title="Link target outside of Sample">Chapter Six</span></p>
<p class="chapter1"><span href="#/Text/Chapter_06#toc-anchor-16" title="Link target outside of Sample">Oddities and Insights</span></p>
<p class="chapter"><span href="#/Text/Chapter_07#toc-anchor-7" title="Link target outside of Sample">Chapter Seven</span></p>
<p class="chapter1"><span href="#/Text/Chapter_07#toc-anchor-17" title="Link target outside of Sample">Bundy: A Man of Letters</span></p>
<p class="chapter"><span href="#/Text/Chapter_08#toc-anchor-8" title="Link target outside of Sample">Chapter Eight</span></p>
<p class="chapter1"><span href="#/Text/Chapter_08#toc-anchor-18" title="Link target outside of Sample">Epilogue</span></p>
<p class="chapter"><span href="#/Text/acknowledgments#toc-anchor-9" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="chapter"><span href="#/Text/about#toc-anchor-10" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
<div class="calibre3" id="calibre_pb_9"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?0583d4cc